import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ImageUrl } from '../../utils/constants';
import { NotificationIcon, LaunchIcon } from '../../utils/icons';
import { ActiveInitiativeCardWrapper } from './styles';
import { CommonButtonPopup } from '../HealthCoach/styles';
import CircularProgressBar from '../common/CircularProgressBar/CircularProgressBar';
import dayjs from 'dayjs';

const ActiveInitiativeCard = ({ details, isArchived ,  onBellClick, onLaunchClick, onCardClick, hideBell, fullWidth }) => {
  const [contentHover, setContentHover] = useState(false);
  const isLaunched = !!details?.launch_date || !!details?.start_date;

  const daysLeft = details?.end_date
    ? Math.ceil((new Date(details.end_date) - new Date()) / (1000 * 60 * 60 * 24))
    : null;



  const isCompleted = daysLeft !== null && daysLeft <= 0;

  return (
    <ActiveInitiativeCardWrapper isPadding={isArchived  ? "24px 2px 16px 16px" : "24px 16px 16px 16px" } borderColor={details?.font_color} color={details?.color} fullWidth={fullWidth}>
      <div className="card-header">
        <div className="icon-wrap">
          <img src={`${ImageUrl}/${details?.initiative_white_icon}`} alt="" />
        </div>
        <div className="name" title={details?.initiative_name}>{details?.initiative_name}</div>
        {(!hideBell && !isCompleted) && (
          <div className="bell-wrap" onClick={() => onBellClick && onBellClick(details)}>
            <NotificationIcon />
          </div>
        )}
      </div>
      {details?.initiative_type && (
        <span className="type-badge">{details.initiative_type}</span>
      )}
      <div style={{ height: '1px', background: '#DCDCDC', margin: '12px 0' }} />

      {isLaunched ? (
        <>
          <div
            className="content-row"
            style={{ position: 'relative' }}
            onMouseEnter={() => setContentHover(true)}
            onMouseLeave={() => setContentHover(false)}
          >
            <div className="progress-wrap">
              <CircularProgressBar
                percentage={details?.user_initiative_taken_percentage || details?.percentage || 0}
                color={'#75B084'}
                size={150}
                strokeWidth={12}
              />
            </div>
            <div className="stats">
              <div className="stat-row">
                <span className="label">Users Completed</span>
                <span className="colon">:</span>
                <span className="val">{details?.total_participation || 0}</span>
              </div>
              <div className="stat-row">
                <span className="label">Users Invited</span>
                <span className="colon">:</span>
                <span className="val">{details?.user_count ?? 0}</span>
              </div>
              {/* {daysLeft !== null && (
                <div className="stat-row">
                  <span className="label">Ends In</span>
                  <span className="colon">:</span>
                  <span className="val">{daysLeft > 0 ? `${daysLeft} Days` : 'Completed'}</span>
                </div>
              )} */}

              {daysLeft !== null && (
                <div className="stat-row">
                  <span className="label">
                    {isArchived ? "Archived On" : isCompleted? "Ended On": "Ends In"}
                  </span>
                  <span className="colon">:</span>
                  <span className="val">
                    {isCompleted
                      ? dayjs(details?.end_date).format('MMM DD, YYYY')
                      : `${daysLeft} Days`}
                  </span>
                </div>
              )}
            </div>
            {contentHover && onCardClick && (
              <div style={{
                position: 'absolute', inset: 0,
                background: 'rgba(0,0,0,0.6)',
                borderRadius: '0 0 8px 8px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                zIndex: 3,
              }}>
                <CommonButtonPopup
                  width="160px"
                  background="#DA6C74"
                  style={{ justifyContent: 'center' }}
                  onClick={() => onCardClick(details)}
                >
                  View Details
                </CommonButtonPopup>
              </div>
            )}
          </div>
        </>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <CommonButtonPopup
            width="200px"
            background="#DA6C74"
            onClick={() => onLaunchClick && onLaunchClick(details)}
          >
            <LaunchIcon />
            Launch Initiative
          </CommonButtonPopup>
        </div>
      )}
    </ActiveInitiativeCardWrapper>
  );
};

ActiveInitiativeCard.propTypes = {
  details: PropTypes.object,
  onBellClick: PropTypes.func,
  onLaunchClick: PropTypes.func,
  onCardClick: PropTypes.func,
  hideBell: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isArchived: PropTypes.bool,
};

export default ActiveInitiativeCard;
